import React, { useState, useReducer } from 'react'
import PropTypes from 'prop-types'
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Grid,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  // FormControlLabel,
  // Switch,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

// Define the initial state
const initialState = {
  name: '',
  description: '',
  authtype: 'none',
  remote_username: '',
  remote_password: '',
  api_key: '',
  custom_param_name: '',
  url: '',
  http_verb: 'POST',
}

// Define the reducer
function reducer(state, action) {
  switch (action.type) {
    case 'SET_FIELD':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'SET_NAME':
      return {
        ...state,
        name: action.value,
      }
    default:
      return state
  }
}

// Define validation
const validate = state => {
  const errors = {}
  if (!state.name) errors.name = 'Name is required'
  if (!state.url) errors.url = 'URL is required'

  switch (state.authtype) {
    case 'basic_auth':
      if (!state.remote_username)
        errors.remote_username = 'Username is required for basic auth'
      if (!state.remote_password)
        errors.remote_password = 'Password is required for basic auth'
      break
    case 'static_bearer':
    case 'custom_header':
    case 'get_param':
      if (!state.api_key)
        errors.api_key = 'API key is required for this auth type'
      if (!state.custom_param_name)
        errors.custom_param_name =
          'Custom parameter name is required for this auth type'
      break
    default:
      break
  }

  return errors
}

const ThirdPartyEndpointForm = ({ initialData, onSubmit }) => {
  const [state, dispatch] = useReducer(reducer, initialData || initialState)
  const [errors, setErrors] = useState({})
  const [expanded, setExpanded] = useState(false)

  const handleChange = e => {
    const { name, value } = e.target
    dispatch({ type: 'SET_FIELD', field: name, value })
    if (!expanded && name === 'url') {
      dispatch({ type: 'SET_NAME', value })
    }
  }

  const handleExpand = (event, isExpanded) => {
    setExpanded(isExpanded)
  }

  const handleSubmit = e => {
    e.preventDefault()
    const validationErrors = validate(state)
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors)
    } else {
      setErrors({})
      onSubmit(state)
    }
  }

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h5" gutterBottom>
        {initialData ? 'Update' : 'Create'} Third Party Endpoint
      </Typography>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <TextField
              label="URL"
              name="url"
              value={state.url}
              onChange={handleChange}
              fullWidth
              error={!!errors.url}
              helperText={errors.url}
              required
            />
          </Grid>
          <ExpansionPanel
            style={{ width: '100%' }}
            expanded={expanded}
            onChange={handleExpand}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Advanced</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid container spacing={8}>
                <Grid item xs={12}>
                  <TextField
                    label="Name"
                    name="name"
                    value={state.name}
                    onChange={handleChange}
                    fullWidth
                    error={!!errors.name}
                    helperText={errors.name}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    label="Description"
                    name="description"
                    value={state.description}
                    onChange={handleChange}
                    fullWidth
                    error={!!errors.description}
                    helperText={errors.description}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    select
                    label="Authentication Type"
                    name="authtype"
                    value={state.authtype}
                    onChange={handleChange}
                    fullWidth
                    required
                  >
                    <MenuItem value="none">None</MenuItem>
                    <MenuItem value="basic_auth">Basic Auth</MenuItem>
                    <MenuItem value="static_bearer">Static Bearer</MenuItem>
                    <MenuItem value="custom_header">Custom Header</MenuItem>
                    <MenuItem value="get_param">GET Param</MenuItem>
                  </TextField>
                </Grid>
                {state.authtype === 'basic_auth' && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label="Username"
                        name="remote_username"
                        value={state.remote_username}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.remote_username}
                        helperText={errors.remote_username}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Password"
                        name="remote_password"
                        type="password"
                        value={state.remote_password}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.remote_password}
                        helperText={errors.remote_password}
                        required
                      />
                    </Grid>
                  </>
                )}
                {(state.authtype === 'static_bearer' ||
                  state.authtype === 'custom_header' ||
                  state.authtype === 'get_param') && (
                  <>
                    <Grid item xs={12}>
                      <TextField
                        label="API Key"
                        name="api_key"
                        value={state.api_key}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.api_key}
                        helperText={errors.api_key}
                        required
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Custom Parameter Name"
                        name="custom_param_name"
                        value={state.custom_param_name}
                        onChange={handleChange}
                        fullWidth
                        error={!!errors.custom_param_name}
                        helperText={errors.custom_param_name}
                        required
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary">
              {initialData ? 'Update' : 'Create'}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  )
}

ThirdPartyEndpointForm.propTypes = {
  initialData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
}

export default ThirdPartyEndpointForm
